/* eslint-disable no-unused-vars */
import React from 'react';
import * as diff from 'diff';
import PropTypes from 'prop-types';
window.diff = diff;

const styles = {
  added: {
    color: 'green',
    backgroundColor: '#b5efdb'
  },
  removed: {
    color: 'red',
    backgroundColor: '#fec4c0'
  }
};

const Diff = ({
  setTtError,
  string1 = '',
  string2 = '',
  mode = 'characters',
  ttError = 0,
  setCtError,
  CtError
}) => {
  let groups = [];
  let intcount = 0;

  // const [intcount, setIntcount] = useState(0);

  if (mode === 'characters') groups = diff.diffChars(string1, string2);
  if (mode === 'words') groups = diff.diffWords(string1, string2);

  const mappedNodes = groups.map(group => {
    const { value, added, removed } = group;
    let nodeStyles;

    if (added) nodeStyles = styles.added;
    if (removed) {
      nodeStyles = styles.removed;

      intcount++;
    }

    return (
      <span key={group.value} style={nodeStyles}>
        {value}
      </span>
    );
  });
  // console.log(intcount);

  // setCtError(intcount);
  // console.log(CtError);
  // setCtError(CtError);
  // console.log(CtError);
  // setTtError(CtError);

  // setTtError(ttError);

  return <span>{mappedNodes}</span>;
};

Diff.propTypes = {
  CtError: PropTypes.any,
  setCtError: PropTypes.any,
  setTtError: PropTypes.any,
  string1: PropTypes.string,
  string2: PropTypes.string,
  ttError: PropTypes.number,
  mode: PropTypes.oneOf(['characters', 'words'])
};

export default Diff;
